import { useMutation } from 'react-query';
import { useServiceError } from '@/hooks';
import managementChartServices from './ManagementChart.services';
import {
  AverageTicketParams,
  BillingExpenseRevenueParams,
  BillingOverviewParams,
  BillingPassAverageTicketParams,
  CashFlowParams,
  ComparasionInsurersParams,
  CostFixedVariableParams,
  CostSalesParams,
  ExpensesIncomeParams,
  PartsServicesParams,
} from './ManagementChart.types';

export function useChartAverageTicket() {
  const mutation = useMutation((params: AverageTicketParams) =>
    managementChartServices.averageTicket(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartExpensesIncome() {
  const mutation = useMutation((params: ExpensesIncomeParams) =>
    managementChartServices.expenseIncome(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartPartsAndServices() {
  const mutation = useMutation((params: PartsServicesParams) =>
    managementChartServices.partsServices(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartCashFlow() {
  const mutation = useMutation((params: CashFlowParams) =>
    managementChartServices.cashFlow(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartCostFixedVariable() {
  const mutation = useMutation((params: CostFixedVariableParams) =>
    managementChartServices.costFixedVariable(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartComparisonInsurers() {
  const mutation = useMutation((params: ComparasionInsurersParams) =>
    managementChartServices.comparisonInsurers(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartCostSales() {
  const mutation = useMutation((params: CostSalesParams) =>
    managementChartServices.costSales(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartBillingOverview() {
  const mutation = useMutation((params: BillingOverviewParams) =>
    managementChartServices.billingOverview(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartBillingExpenseRevenue() {
  const mutation = useMutation((params: BillingExpenseRevenueParams) =>
    managementChartServices.billingExpenseRevenue(params),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useChartBillingPassAverageTicket() {
  const mutation = useMutation((params: BillingPassAverageTicketParams) =>
    managementChartServices.billingPassAverageTicket(params),
  );

  useServiceError(mutation.error);

  return mutation;
}
